import { render } from "./statuteInfo.vue?vue&type=template&id=5ddc817b&scoped=true"
import script from "./statuteInfo.vue?vue&type=script&lang=js"
export * from "./statuteInfo.vue?vue&type=script&lang=js"

import "./statuteInfo.vue?vue&type=style&index=0&id=5ddc817b&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddc817b"]])

export default __exports__